exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".category-label[data-v-b7083e30]{justify-content:flex-end}table[data-v-b7083e30]{margin:auto}th[data-v-b7083e30]{min-width:4rem}.quota-status[data-v-b7083e30]{position:absolute;font-size:1.25rem;margin-top:.75rem;margin-left:.375rem}.quota-status.check[data-v-b7083e30]{color:rgba(0,255,0,.75)}.quota-status.close[data-v-b7083e30]{color:rgba(255,0,0,.75)}.impact-today[data-v-b7083e30]{font-size:.75rem}.impact-icon[data-v-b7083e30]{font-size:.75rem;font-weight:700;position:relative;top:2px}.impact-icon.keyboard_arrow_down[data-v-b7083e30]{color:red}.impact-icon.keyboard_arrow_up[data-v-b7083e30]{color:green}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-b7083e30&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/views/TrendView.vue
// module id = ./node_modules/css-loader/index.js?minimize!./node_modules/vue-loader/lib/style-rewriter.js?id=data-v-b7083e30&scoped=true!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/views/TrendView.vue
// module chunks = 0